// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nv-1";
export var messageSideRight = "_nv-2";
export var orderLookupBubbleContainer = "_nv-0";
export var submitButton = "_nv-3";